__turbopack_context__.v({
  "button": "ButtonToTop-module-scss-module__ygxIHa__button",
  "buttonIcon": "ButtonToTop-module-scss-module__ygxIHa__buttonIcon",
});
